import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import classes from './User.module.scss';
import { Container, Checkbox, Grid, Stack, TextField, Button, FormControl } from '@mui/material';
import { Topheader } from './../../components/Topheader';
import { ErrorMessage } from './../../components/Message/ErrorMessage';
import { SuccessMessage } from './../../components/Message/SuccessMessage';
import { regularUserAdd, fetchDetails } from '../../actions/AdminUserAction';
import { getErrorMessage } from '../../helpers/commonFunction';
import IntegrationDownshift from './../../helpers/multiSelect';
import { makePhoneNumberForDB } from '../../helpers/util';
import config from './../../constants/config';
import validator from '../../helpers/checkValidations';
import LoadingOverlay from 'react-loading-overlay';
import {
  changeHandler,
  getValidationStyle,
  handleChangeCheckbox,
  getFeeSettingPermissionTitle,
} from './CommonFunction';
import AmountTextField from '../../components/FeeDisplay/AmountTextField';
import { BackButton } from '../../components/Buttons';

class AddManager extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      userName: '',
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      role: config.MANAGER_ROLE,
      sideShow: true,
      isLoading: true,
      isLocation: false,
      createdBy: '',
      company: '',
      data: [],
      misMatchError: [],
      enableBatchTransactionReportNotification: false,
      permissions: {
        refunds: false,
        refundsManual: false,
        exportRecord: false,
        allLocaton: false,
        creatNewUser: false,
        createInvoice: false,
        ach: false,
        virtualTerminal: false,
        recurring: false,
        textToInvoice: false,
        textInvoice: false,
        textNotifications: false,
        feeEdit: false,
        void: false,
        perTransactionLimit: '',
        dailyTransactionLimit: '',
        perRefundLimit: '',
        emailVisibilityTerminal: true,
        notesVisibilityTerminal: true,
        dailyRefundLimit: '',
        emailNotification: false,
        declineEmailNotification: false,
        deleteInvoice: false,
        viewAllTransactions: false,
        displayProducts: true,
        displayDashboard: true,
        displaySettings: false,
        displayTickets: true,
        displayLocations: true,
        displayUsers: true,
        displayTransactions: true,
      },
      userData: { permissions: {} },
      isSubmit: false,
      locationSelected: '',
      user: JSON.parse(localStorage.getItem('user')),
      error: {
        UserNameError: false,
        firstNameError: false,
        lastNameError: false,
        emailError: false,
        perTransactionLimitError: false,
        dailyTransactionLimitError: false,
        perRefundLimitError: false,
        dailyRefundLimitError: false,
      },
      marginBottom: '10',
    };
    this.containerRef = React.createRef();
  }

  componentDidMount() {
    this.setState({
      createdBy: this.state.user._id,
      isLoading: false,
    });

    let user = JSON.parse(localStorage.getItem('user'));
    let data = fetchDetails({ id: user._id });
    data.then((res) => {
      if (res.type === 'FETCH_SUCCESS') {
        this.setState(
          {
            dataLoc: { ...res.payload.userData.location },
            userData: { ...res.payload.userData },
            company: { ...res.payload.userData.company },
          },
          () => {
            if (this.state.userData.permissions && !this.state.userData.permissions.creatNewUser) {
              alert('Access denied!');
              this.props.history.push('/Dashboard');
            }
            Object.keys(this.state.dataLoc).forEach((k, _v) => {
              this.state.data.push(this.state.dataLoc[k]);
            });
            if (this.state.data.length > 0) {
              this.setState({
                locationSelected: Object.keys(this.state.data).map((k, _v) => this.state.data[k].id),
              });
            }
          }
        );
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.locationSelected !== this.state.locationSelected) {
      this.updateMarginBottom();
      getValidationStyle(!this.state.locationSelected && this.state.isSubmit, this.state.marginBottom);
    }
  }

  updateMarginBottom() {
    const container = this.containerRef.current;
    if (container.scrollHeight > container.clientHeight) {
      this.setState({ marginBottom: container.scrollHeight });
    }
  }

  onHandleChangeCheckbox(event) {
    const permissions = handleChangeCheckbox(event, this.state);
    this.setState({ permissions });
  }

  onHandleChange(event) {
    const { id, value, misMatchError, error, validationMarkup, permissions, validatePhone } = changeHandler(
      event,
      this.state
    );

    if (!validationMarkup || !validatePhone) {
      return false;
    }
    this.setState({
      [id]: value,
      permissions,
      error,
      misMatchError,
      isSubmit: false,
      successMessages: false,
    });
  }

  handleSubmit(_e, t) {
    let misMatchError = [];
    let successMessages = false;
    let state = this.state;
    let error = {};
    let errorFlag = false;
    this.setState({ isSubmit: true });

    Object.keys(state).forEach((keyValues, _value) => {
      if (
        keyValues === 'phone' &&
        !this.state.permissions.textFlex &&
        !this.state.permissions.textInvoice &&
        !this.state.permissions.textToInvoice
      ) {
        return false;
      }
      if (validator(keyValues, state[keyValues])) {
        return validator(keyValues, state[keyValues])
          ? ((error[keyValues + 'Error'] = true), (errorFlag = true))
          : (error[keyValues + 'Error'] = false);
      } else {
        return state[keyValues] === '' || (typeof state[keyValues] === 'string' && state[keyValues].trim() === '')
          ? ((error[keyValues + 'Error'] = true), (errorFlag = true))
          : '';
      }
    });
    Object.keys(this.state.permissions).forEach((key, _value) => {
      if (key === 'phoneNumber' || key === 'amount') {
        return false;
      }
      if (validator(key, state.permissions[key])) {
        return validator(key, state.permissions[key])
          ? ((error[key + 'Error'] = true), (errorFlag = true))
          : (error[key + 'Error'] = false);
      } else {
        return state.permissions[key] === '' ||
          (typeof state.permissions[key] === 'string' && state.permissions[key].trim() === '')
          ? ((error[key + 'Error'] = true), (errorFlag = true))
          : '';
      }
    });

    if (state.locationSelected.length === 0) {
      misMatchError.push(t('LocationRequired'));
      errorFlag = true;
      this.setState({ misMatchError });
    }

    if (errorFlag) {
      window.scrollTo(0, 0, 0);
      this.setState({ misMatchError, error, successMessages });
      return false;
    } else {
      this.setState({ isLoading: true });
      this.props.regularUserAdd({ ...this.state, phone: makePhoneNumberForDB(this.state.phone) }).then((result) => {
        window.scrollTo(0, 0, 0);
        if (result !== undefined && result.type === 'USER_SUCCESS') {
          this.setState({ successMessages: true, misMatchError, isLoading: false }, () => {
            setTimeout(() => {
              this.setState({ redirect: true, successMessages: false });
            }, 2000);
          });
        }
        if (result !== undefined && result.type === 'USER_ERROR') {
          this.setState({
            misMatchError: getErrorMessage(result),
            successMessages,
            isLoading: false,
          });
        }
      });
    }
  }

  addLocation = (arr) => {
    let misMatchError = [];
    this.setState({ locationSelected: arr, misMatchError });
  };

  render() {
    const { t } = this.props;
    const { data, redirect } = this.state;

    return (
      <div className="rightPanel">
        {redirect ? <Redirect to="/Users" /> : ''}

        <Topheader />
        <LoadingOverlay active={this.state.isLoading} spinner text="Loading your content...">
          <Container component="main" maxWidth={false}>
            {this.state.misMatchError.length > 0 ? <ErrorMessage errors={[this.state.misMatchError]} /> : ''}
            {this.state.successMessages ? <SuccessMessage successes={[this.props.info.userInfo.data.message]} /> : ''}

            <form className={classes.form} noValidate>
              <Grid container spacing={3}>
                <Grid item xs={6} sm={3}>
                  <TextField
                    required
                    error={this.state.error.userNameError}
                    id="userName"
                    type="text"
                    label={t('Username')}
                    value={this.state.userName}
                    fullWidth
                    onChange={(e) => this.onHandleChange(e, t)}
                    autoFocus
                    variant="standard"
                  />
                </Grid>
                <Grid item xs={6} sm={3}>
                  <TextField
                    required
                    error={this.state.error.firstNameError}
                    id="firstName"
                    type="text"
                    label={t('FirstName')}
                    value={this.state.firstName}
                    fullWidth
                    onChange={(e) => this.onHandleChange(e, t)}
                    variant="standard"
                  />
                </Grid>
                <Grid item xs={6} sm={3}>
                  <TextField
                    required
                    error={this.state.error.lastNameError}
                    id="lastName"
                    type="text"
                    label={t('LastName')}
                    value={this.state.lastName}
                    fullWidth
                    onChange={(e) => this.onHandleChange(e, t)}
                    variant="standard"
                  />
                </Grid>
                <Grid item xs={6} sm={3}>
                  <TextField
                    required={
                      this.state.permissions.textFlex ||
                      this.state.permissions.textInvoice ||
                      this.state.permissions.textToInvoice
                    }
                    error={
                      this.state.permissions.textFlex ||
                      this.state.permissions.textInvoice ||
                      this.state.permissions.textToInvoice
                        ? this.state.error.phoneError
                        : false
                    }
                    id="phone"
                    type="text"
                    label={t('Phone')}
                    value={this.state.phone}
                    fullWidth
                    onChange={(e) => this.onHandleChange(e, t)}
                    autoFocus
                    variant="standard"
                  />
                </Grid>
                <Grid item xs={6} sm={3}>
                  <TextField
                    required
                    error={this.state.error.emailError}
                    id="email"
                    type="email"
                    label={t('Email')}
                    value={this.state.email}
                    fullWidth
                    onChange={(e) => this.onHandleChange(e, t)}
                    variant="standard"
                  />
                </Grid>
                <Grid item xs={6}>
                  <FormControl
                    fullWidth
                    style={getValidationStyle(
                      !this.state.locationSelected && this.state.isSubmit,
                      this.state.marginBottom
                    )}
                    ref={this.containerRef}
                  >
                    <IntegrationDownshift
                      isLocationExists={true}
                      selectedLocations={data}
                      locationData={data}
                      addLocation={this.addLocation}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={6} sm={3} />
                <Grid item xs={6} sm={3}>
                  <AmountTextField
                    id="perTransactionLimit"
                    label={t('PerTransactionLimit')}
                    amount={this.state.permissions.perTransactionLimit}
                    setAmount={(newAmount) => {
                      this.setState({
                        perTransactionLimit: newAmount,
                        permissions: { ...this.state.permissions, perTransactionLimit: newAmount },
                        error: {
                          ...this.state.error,
                          perTransactionLimitError: validator('perTransactionLimit', newAmount),
                        },
                      });
                    }}
                    error={this.state.error.perTransactionLimitError}
                    required
                    fullWidth
                  />
                </Grid>
                <Grid item xs={6} sm={3}>
                  <AmountTextField
                    id="dailyTransactionLimit"
                    label={t('DailyTransactionLimit')}
                    amount={this.state.permissions.dailyTransactionLimit}
                    setAmount={(newAmount) => {
                      this.setState({
                        dailyTransactionLimit: newAmount,
                        permissions: { ...this.state.permissions, dailyTransactionLimit: newAmount },
                        error: {
                          ...this.state.error,
                          dailyTransactionLimitError: validator('dailyTransactionLimit', newAmount),
                        },
                      });
                    }}
                    error={this.state.error.dailyTransactionLimitError}
                    required
                    fullWidth
                  />
                </Grid>
                <Grid item xs={6} sm={3}>
                  <AmountTextField
                    id="perRefundLimit"
                    label={t('PerRefundLimit')}
                    amount={this.state.permissions.perRefundLimit}
                    setAmount={(newAmount) => {
                      this.setState({
                        perRefundLimit: newAmount,
                        permissions: { ...this.state.permissions, perRefundLimit: newAmount },
                        error: {
                          ...this.state.error,
                          perRefundLimitError: validator('perRefundLimit', newAmount),
                        },
                      });
                    }}
                    error={this.state.error.perRefundLimitError}
                    required
                    fullWidth
                  />
                </Grid>
                <Grid item xs={6} sm={3}>
                  <AmountTextField
                    id="dailyRefundLimit"
                    label={t('DailyRefundLimit')}
                    amount={this.state.permissions.dailyRefundLimit}
                    setAmount={(newAmount) => {
                      this.setState({
                        dailyRefundLimit: newAmount,
                        permissions: { ...this.state.permissions, dailyRefundLimit: newAmount },
                        error: {
                          ...this.state.error,
                          dailyRefundLimitError: validator('dailyRefundLimit', newAmount),
                        },
                      });
                    }}
                    error={this.state.error.dailyRefundLimitError}
                    required
                    fullWidth
                  />
                </Grid>
                <Grid item xs={6} sm={3} style={{ marginTop: 20 }}>
                  <label>
                    <Checkbox
                      id="enableBatchTransactionEmailNotification"
                      color="primary"
                      onChange={(event) => {
                        this.setState({ enableBatchTransactionReportNotification: event.target.checked });
                      }}
                      checked={this.state.enableBatchTransactionReportNotification}
                      value={this.state.enableBatchTransactionReportNotification}
                      inputProps={{
                        'aria-label': 'secondary checkboxes',
                      }}
                    />
                    <span>{t('BatchTransactionNotification')}</span>
                  </label>
                </Grid>

                <Grid item xs={12}>
                  <h5>Permissions</h5>
                  <Grid container item xs={12}>
                    {this.state.role < 4 ? (
                      <Grid item xs={12} sm={6}>
                        <label>
                          <Checkbox
                            id="creatNewUser"
                            labels="creatNewUser"
                            onChange={(e) => {
                              this.onHandleChangeCheckbox(e);
                            }}
                            value={this.state.permissions.creatNewUser}
                            color="primary"
                            inputProps={{
                              'aria-label': 'secondary checkbox',
                            }}
                          />
                          <span>Create New User</span>
                        </label>
                      </Grid>
                    ) : (
                      ''
                    )}
                    <Grid item xs={12} sm={6}>
                      <label>
                        <Checkbox
                          id="refunds"
                          onChange={(e) => {
                            this.onHandleChangeCheckbox(e);
                          }}
                          value={this.state.permissions.refunds}
                          color="primary"
                          inputProps={{
                            'aria-label': 'secondary checkbox',
                          }}
                        />
                        <span>Refunds General</span>
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <label>
                        <Checkbox
                          value={this.state.refundsManual}
                          id="refundsManual"
                          checked={this.state.permissions.refundsManual}
                          onChange={(event) => {
                            this.onHandleChangeCheckbox(event);
                          }}
                          inputProps={{
                            'aria-label': 'secondary checkbox',
                          }}
                          color="primary"
                        />
                        <span>Refunds Manual</span>
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <label>
                        <Checkbox
                          id="allLocaton"
                          onChange={(e) => {
                            this.onHandleChangeCheckbox(e);
                          }}
                          value={this.state.permissions.allLocaton}
                          color="primary"
                          inputProps={{
                            'aria-label': 'secondary checkbox',
                          }}
                        />
                        <span>All Location</span>
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <label>
                        <Checkbox
                          id="createInvoice"
                          onChange={(e) => {
                            this.onHandleChangeCheckbox(e);
                          }}
                          value={this.state.permissions.createInvoice}
                          color="primary"
                          inputProps={{
                            'aria-label': 'secondary checkbox',
                          }}
                        />
                        <span>Invoicing</span>
                      </label>
                    </Grid>
                    {this.state.company.ACH && (
                      <Grid item xs={12} sm={6}>
                        <label>
                          <Checkbox
                            id="ach"
                            onChange={(e) => {
                              this.onHandleChangeCheckbox(e);
                            }}
                            value={this.state.permissions.ach}
                            color="primary"
                            inputProps={{
                              'aria-label': 'secondary checkbox',
                            }}
                          />
                          <span>ACH </span>
                        </label>
                      </Grid>
                    )}
                    <Grid item xs={12} sm={6}>
                      <label>
                        <Checkbox
                          id="virtualTerminal"
                          onChange={(e) => {
                            this.onHandleChangeCheckbox(e);
                          }}
                          value={this.state.permissions.virtualTerminal}
                          color="primary"
                          inputProps={{
                            'aria-label': 'secondary checkbox',
                          }}
                        />
                        <span>Virtual Terminal</span>
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <label>
                        <Checkbox
                          id="recurring"
                          onChange={(e) => {
                            this.onHandleChangeCheckbox(e);
                          }}
                          value={this.state.permissions.recurring}
                          color="primary"
                          inputProps={{
                            'aria-label': 'secondary checkbox',
                          }}
                        />
                        <span>Recurring Billing</span>
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <label>
                        <Checkbox
                          id="exportRecord"
                          onChange={(e) => {
                            this.onHandleChangeCheckbox(e);
                          }}
                          value={this.state.permissions.exportRecord}
                          color="primary"
                          inputProps={{
                            'aria-label': 'secondary checkbox',
                          }}
                        />
                        <span>Export Records</span>
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <label>
                        <Checkbox
                          id="feeEdit"
                          onChange={(e) => {
                            this.onHandleChangeCheckbox(e);
                          }}
                          value={this.state.permissions.feeEdit}
                          color="primary"
                          inputProps={{
                            'aria-label': 'secondary checkbox',
                          }}
                        />
                        <span>{getFeeSettingPermissionTitle(this.state.role)}</span>
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <label>
                        <Checkbox
                          id="void"
                          onChange={(e) => {
                            this.onHandleChangeCheckbox(e);
                          }}
                          value={this.state.permissions.void}
                          color="primary"
                          inputProps={{
                            'aria-label': 'secondary checkbox',
                          }}
                        />
                        <span>Void</span>
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <label>
                        <Checkbox
                          id="emailNotification"
                          onChange={(e) => {
                            this.onHandleChangeCheckbox(e);
                          }}
                          value={this.state.permissions.emailNotification}
                          color="primary"
                          inputProps={{
                            'aria-label': 'secondary checkbox',
                          }}
                        />
                        <span>{t('emailNotifications')}</span>
                      </label>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <label>
                        <Checkbox
                          checked={this.state.permissions.deleteInvoice}
                          id="deleteInvoice"
                          onChange={(e) => {
                            this.onHandleChangeCheckbox(e);
                          }}
                          value={this.state.deleteInvoice}
                          color="primary"
                          inputProps={{
                            'aria-label': 'secondary checkbox',
                          }}
                        />
                        <span>{t('DeleteInvoice')}</span>
                      </label>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <label>
                        <Checkbox
                          id="declineEmailNotification"
                          onChange={(e) => {
                            this.onHandleChangeCheckbox(e);
                          }}
                          value={this.state.permissions.declineEmailNotification}
                          color="primary"
                          inputProps={{
                            'aria-label': 'secondary checkbox',
                          }}
                        />
                        <span>{t('declineEmailNotifications')}</span>
                      </label>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <label>
                        <Checkbox
                          id="viewAllTransactions"
                          onChange={(e) => {
                            this.onHandleChangeCheckbox(e);
                          }}
                          value={this.state.permissions.viewAllTransactions}
                          color="primary"
                          inputProps={{
                            'aria-label': 'secondary checkbox',
                          }}
                        />
                        <span>View All Transactions</span>
                      </label>
                    </Grid>

                    {this.state.role > 4 ? (
                      <Grid item xs={12} sm={6}>
                        <Checkbox
                          id="creatNewUser"
                          onChange={(e) => {
                            this.onHandleChangeCheckbox(e);
                          }}
                          value={this.state.permissions.creatNewUser}
                          color="primary"
                          inputProps={{
                            'aria-label': 'secondary checkbox',
                          }}
                        />
                        <label>
                          <span>Create New User</span>
                        </label>
                      </Grid>
                    ) : (
                      ''
                    )}

                    <Grid item xs={12} sm={6}>
                      <Grid item xs={12} sm={6}>
                        <label>
                          <Checkbox
                            id="textToInvoice"
                            onChange={(e) => {
                              this.onHandleChangeCheckbox(e);
                            }}
                            value={this.state.permissions.textToInvoice}
                            checked={this.state.permissions.textToInvoice}
                            color="primary"
                            inputProps={{
                              'aria-label': 'secondary checkbox',
                            }}
                          />
                          <span>Texting</span>
                        </label>
                      </Grid>
                      <Grid item xs={12} sm={6} style={{ marginLeft: 10 }}>
                        <label>
                          <Checkbox
                            id="textNotifications"
                            onChange={(e) => {
                              this.onHandleChangeCheckbox(e);
                            }}
                            value={this.state.permissions.textNotifications}
                            checked={this.state.permissions.textNotifications}
                            color="primary"
                            inputProps={{
                              'aria-label': 'secondary checkbox',
                            }}
                          />
                          <span>Text Notifications</span>
                        </label>
                      </Grid>
                      <Grid item xs={12} sm={6} style={{ marginLeft: 10 }}>
                        <label>
                          <Checkbox
                            id="textInvoice"
                            checked={this.state.permissions.textInvoice}
                            onChange={(e) => {
                              this.onHandleChangeCheckbox(e);
                            }}
                            value={this.state.permissions.textInvoice}
                            inputProps={{
                              'aria-label': 'secondary checkbox',
                            }}
                            color="primary"
                          />
                          <span>Text Invoice</span>
                        </label>
                      </Grid>
                    </Grid>
                  </Grid>{' '}
                  <h4>Terminal Field Display</h4>
                  <Grid container item xs={12}>
                    <Grid item xs={12} sm={6}>
                      <label>
                        <Checkbox
                          id="emailVisibilityTerminal"
                          color="primary"
                          onChange={(event) => {
                            this.onHandleChangeCheckbox(event);
                          }}
                          inputProps={{
                            'aria-label': 'secondary checkboxx',
                          }}
                          checked={this.state.permissions.emailVisibilityTerminal}
                          value={this.state.permissions.emailVisibilityTerminal}
                        />
                        <span>Email</span>
                      </label>
                      <label>
                        <Checkbox
                          id="notesVisibilityTerminal"
                          color="primary"
                          onChange={(event) => {
                            this.onHandleChangeCheckbox(event);
                          }}
                          inputProps={{
                            'aria-label': 'secondary checkboxx',
                          }}
                          checked={this.state.permissions.notesVisibilityTerminal}
                          value={this.state.notesVisibilityTerminal}
                        />
                        <span>Notes</span>
                      </label>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  <h5>Main Menu Display</h5>
                  <Grid container item xs={12}>
                    <Grid item xs={12} sm={6}>
                      <label>
                        <Checkbox
                          id="displayDashboard"
                          onChange={(e) => {
                            this.onHandleChangeCheckbox(e);
                          }}
                          checked={this.state.permissions.displayDashboard}
                          value={this.state.permissions.displayDashboard}
                          color="primary"
                          inputProps={{
                            'aria-label': 'secondary checkbox',
                          }}
                        />
                        <span>Dashboard</span>
                      </label>
                    </Grid>
                  </Grid>
                  <Grid container item xs={12}>
                    <Grid item xs={12} sm={6}>
                      <label>
                        <Checkbox
                          id="displayTickets"
                          onChange={(e) => {
                            this.onHandleChangeCheckbox(e);
                          }}
                          checked={this.state.permissions.displayTickets}
                          value={this.state.permissions.displayTickets}
                          color="primary"
                          inputProps={{
                            'aria-label': 'secondary checkbox',
                          }}
                        />
                        <span>Tickets</span>
                      </label>
                    </Grid>
                  </Grid>
                  <Grid container item xs={12}>
                    <Grid item xs={12} sm={6}>
                      <label>
                        <Checkbox
                          id="displayLocations"
                          onChange={(e) => {
                            this.onHandleChangeCheckbox(e);
                          }}
                          checked={this.state.permissions.displayLocations}
                          value={this.state.permissions.displayLocations}
                          color="primary"
                          inputProps={{
                            'aria-label': 'secondary checkbox',
                          }}
                        />
                        <span>Locations</span>
                      </label>
                    </Grid>
                  </Grid>
                  <Grid container item xs={12}>
                    <Grid item xs={12} sm={6}>
                      <label>
                        <Checkbox
                          id="displayTransactions"
                          onChange={(e) => {
                            this.onHandleChangeCheckbox(e);
                          }}
                          checked={this.state.permissions.displayTransactions}
                          value={this.state.permissions.displayTransactions}
                          color="primary"
                          inputProps={{
                            'aria-label': 'secondary checkbox',
                          }}
                        />
                        <span>Transactions</span>
                      </label>
                    </Grid>
                  </Grid>
                  <Grid container item xs={12}>
                    <Grid item xs={12} sm={6}>
                      <label>
                        <Checkbox
                          id="displayProducts"
                          onChange={(e) => {
                            this.onHandleChangeCheckbox(e);
                          }}
                          checked={this.state.permissions.displayProducts}
                          value={this.state.permissions.displayProducts}
                          color="primary"
                          inputProps={{
                            'aria-label': 'secondary checkbox',
                          }}
                        />
                        <span>Products</span>
                      </label>
                    </Grid>
                  </Grid>
                  <Grid container item xs={12}>
                    <Grid item xs={12} sm={6}>
                      <label>
                        <Checkbox
                          id="displayUsers"
                          onChange={(e) => {
                            this.onHandleChangeCheckbox(e);
                          }}
                          checked={this.state.permissions.displayUsers}
                          value={this.state.permissions.displayUsers}
                          color="primary"
                          inputProps={{
                            'aria-label': 'secondary checkbox',
                          }}
                        />
                        <span>Users</span>
                      </label>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container item xs={12}>
                  <Stack spacing={2} direction="row">
                    <Button
                      id="signUp"
                      type="button"
                      variant="contained"
                      color="primary"
                      onClick={(event) => this.handleSubmit(event, t)}
                    >
                      {t('Save')}
                    </Button>
                    <BackButton />
                  </Stack>
                </Grid>
              </Grid>
            </form>
          </Container>
        </LoadingOverlay>
      </div>
    );
  }
}
AddManager.propTypes = {
  t: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    info: state.AdminUserReducer,
  };
}

AddManager.propTypes = {
  regularUserAdd: PropTypes.func,
  info: PropTypes.object,
  history: PropTypes.object,
};

export default connect(mapStateToProps, { fetchDetails, regularUserAdd })(withTranslation()(AddManager));
